import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Tab } from '../../../components';
import { ArchivedTab } from './ArchivedTab';
import { CompletedTab } from './CompletedTab';
import { IncompleteTab } from './IncompleteTab';
import { PendingTab } from './PendingTab';
import { ScheduledTab } from './ScheduledTab';
import * as S from './BookingsTab.styles';

export const BookingsTab = ({ resource, role }) => {
	const [tabs, setTabs] = useState([
		{
			id: 1,
			label: 'Pending',
			component: <PendingTab resource={resource} role={role} />,
		},
		{
			id: 2,
			label: 'Scheduled',
			component: <ScheduledTab resource={resource} role={role} />,
		},
		{
			id: 3,
			label: 'Completed',
			component: <CompletedTab resource={resource} role={role} />,
		},
		{
			id: 4,
			label: 'Incomplete',
			component: <IncompleteTab resource={resource} role={role} />,
		},
		{
			id: 5,
			label: 'Archived',
			component: <ArchivedTab resource={resource} role={role} />,
		},
	]);

	return (
		<S.Wrapper>
			<Tab tabs={tabs} setTabs={setTabs} transparent variation="pill" />
		</S.Wrapper>
	);
};

BookingsTab.propTypes = {
	resource: PropTypes.object,
	role: PropTypes.string,
};
